/**
 * @module
 * @description A plugin to change Vuex to use localStorage instead of sessionStorage
 * @example
 * // In your @/store
 * import Vue from 'vue';
 * import Vuex from 'vuex';
 * import tokeny from '@tokenyico/vuejs-toolkit/src/exports/store/tokeny';
 * import locale from '@tokenyico/vuejs-toolkit/src/exports/store/locale';
 * import persist from '@tokenyico/vuejs-toolkit/src/exports/store/persist';
 * Vue.use(Vuex);
 * export default new Vuex.Store({
 *   modules: { locale, tokeny },
 *   plugins: [persist.plugin]
 * });
 */
import VuexPersistence from 'vuex-persist';

const persist = new VuexPersistence({
  storage: window.sessionStorage
});

/**
 * @name default
 * @type {object}
 */
export default persist;
